import { downloadAction } from '@op/pages/download/utils/index';
import { notificationError } from '@/pages/opinion/pages/report/gpt/constant';
import { useIntl, useSelector } from 'umi';
import { aigcCreateStreamingSummary, aigcCreateTaskId } from '@op/services';
import { useState } from 'react';
import { ModelType, PromptConfirmItemType } from '../types';
import { NO_DATE } from '@op/constants';

export function useConfirm({
  filter,
  gameInfo,
  setRemainder,
  modelType = 'default',
}: {
  filter: any;
  gameInfo: any;
  setRemainder?: (value: number) => void;
  modelType?: ModelType;
}) {
  const [loading, setLoading] = useState(false);
  const { formatMessage } = useIntl();
  const { oriFilter } = useSelector(
    (state: any) => state.opinionAIShortIdFilter,
  );

  // function eMailConfirm(emailList: Array<string>, currentFilter = filter) {
  //   setLoading(true);
  //   const downLoadParams = { ...currentFilter, emails: emailList, ...gameInfo };

  //   // 发送请求
  //   getFeedsCommentsToGPTReport(downLoadParams)
  //     .then(() => {
  //       notificationSuccess(formatMessage({ id: 'Subscription successful.' }));
  //     })
  //     .catch(() => {
  //       notificationError(formatMessage({ id: 'Subscription failure' }));
  //     })
  //     .finally(() => {
  //       setLoading(false);
  //     });
  // }

  function downloadAdvanceConfirm(
    taskId: string,
    promptInfo: PromptConfirmItemType,
  ) {
    return downloadAction({
      key:
        promptInfo.gptOptions === 'advanced'
          ? 'GptAdvanceDownload'
          : 'GptCommonDownload',
      filter: {
        ...gameInfo,
        game_id: gameInfo?.edition_unified_id,
        task_id: taskId,
        prompt: promptInfo.prompt,
      },
      auxiliaryParams: {
        promptInfo,
        advanceFilter: { ...gameInfo, task_id: taskId },
      },
      fileName: promptInfo.gptOptions === 'basic' ? 'AIGC' : 'Advance Gpt',
    });
  }

  async function defaultConfirm(
    promptInfo: PromptConfirmItemType,
    currentFilter = filter,
  ) {
    const params = { ...currentFilter, ...gameInfo };

    return aigcCreateTaskId({
      filter: params,
      promptInfo,
      oriFilter,
      shortIdErrorMessage: formatMessage({
        id: 'The network is unstable. Failed to load filters. Please try again.',
      }),
    }).then(async (data: any) => {
      const { task_id: taskId } = data || {};
      if (!taskId) return null;
      if (promptInfo.resultType === 'download') {
        await downloadAdvanceConfirm(taskId, promptInfo);
        return null;
      }
      return data;
    });
  }

  async function streamingConfirm(
    promptInfo: PromptConfirmItemType,
    currentFilter = filter,
  ) {
    const { live_id, start_time, end_time } = currentFilter;
    // 请求创建接口
    return aigcCreateStreamingSummary({
      live_id,
      prompt: promptInfo.prompt,
      start_time,
      end_time,
    }).then(() => 'success');
  }

  const createModelMap: {
    [key in ModelType]: (
      promptInfo: PromptConfirmItemType,
      currentFilter: any,
    ) => Promise<any>;
  } = {
    default: defaultConfirm,
    streaming: streamingConfirm,
  };

  async function advancedConfirm(
    promptInfo: PromptConfirmItemType,
    currentFilter = filter,
    needShowTips = true,
  ) {
    setLoading(true);
    const createModel = createModelMap[modelType];

    return createModel(promptInfo, currentFilter)
      .catch((err: any) => {
        let errorText = '';
        if (err.code === 30018) {
          setRemainder?.(0);
        } else if (err.code === 40001) {
          errorText = needShowTips
            ? 'Due to insufficient selected content, GPT is currently unable to summarize the report as requested.'
            : NO_DATE.SELECTION;
        } else {
          errorText = 'Summary API is currently unstable, please try again';
        }
        if (needShowTips && errorText) {
          notificationError(formatMessage({ id: errorText }));
        }
        throw err;
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return { advancedConfirm, loading, downloadAdvanceConfirm };
}
